<template>
  <div>
    <div class="page-container">
      <div class="page-head">
        <button class="btn-back" @click="goBack">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
          返回
        </button>
        <div class="page-head-text">
          <h1 class="page-title">中药开方</h1>
          <p class="page-subtitle">填写诊疗与用药信息，快速完成处方组方</p>
        </div>
      </div>
      <section class="main-card">
        <div class="main-grid">
          <div class="main-left">
            <section class="section-block">
              <div class="section-head">
                <span class="section-bar"></span>
                <h2 class="section-title">诊疗信息</h2>
              </div>
              <div class="section-body">
                <el-form label-width="120px" label-position="right">
                  <el-form-item label="*接诊类型：" class="form-item">
                    <el-radio-group class="radio-group" v-model="diagnosisType">
                      <el-radio-button class="radio-button" label="初诊" border>初诊</el-radio-button>
                      <el-radio-button class="radio-button" label="复诊" border>复诊</el-radio-button>
                    </el-radio-group>
                  </el-form-item>

                  <!-- 症状信息（可折叠，复用 SymptomTable 组件） -->
                  <SymptomTable v-if="submitData" :basicTableArray="basicTableArray"
                    :shangjiaoTableArray="shangjiaoTableArray" :zhongjiaoTableArray="zhongjiaoTableArray"
                    :xiajiaoTableArray="xiajiaoTableArray" :bare="true" class="symptom-card" />

                  <el-form-item label="*询诊结果：" class="form-item form-textarea">
                    <el-input v-model="diagnoseResult" type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" placeholder="请输入诊断信息" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="*服药时间：" class="form-item">
                    <el-radio-group class="radio-group" v-model="takeMedTime">
                      <el-radio-button class="radio-button" label="饭前服用" border>饭前服用</el-radio-button>
                      <el-radio-button class="radio-button" label="饭后服用" border>饭后服用</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                  <!-- <el-form-item label="*开始日期：" class="form-item">
          <el-date-picker class="dialog-picker" v-model="startDate" placeholder="请选择开始日期" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" @change="startDateChange" type="date" size="large" prefix-icon="clear">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="*结束日期：" class="form-item">
          <el-date-picker class="dialog-picker" v-model="endDate" placeholder="请选择结束日期" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" @change="endDateChange" type="date" size="large" prefix-icon="clear">
          </el-date-picker>
        </el-form-item> -->
                  <div class="btnBox">
                    <el-button type="primary" style="width: 150px" @click="openClassicPrescriptions">经典名方</el-button>
                    <el-button type="primary" style="width: 150px; margin-left: 20px"
                      @click="dialoglscf = true">历史处方</el-button>
                  </div>

                </el-form>
              </div>
            </section>
            <section class="section-block section-block-gap">
              <div class="section-head section-head-between">
                <div class="section-head-left">
                  <span class="section-bar"></span>
                  <h2 class="section-title">开方组方</h2>
                </div>
                <!-- <span class="count-badge">{{ herbCount }} 味药材 · {{ herbTotalWeight }}g</span> -->
              </div>
              <div class="add-form">
                <el-select v-model="selectDrug" filterable @change="changeSelect" placeholder="请选择药品"
                  style="width: 300px">
                  <el-option v-for="item in drugList" :key="item.value"
                    :label="item.piecesWeight ? item.label + '（颗粒）' : item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select style="width: 120px; margin-left: 10px; margin-right: 10px" v-model="medicineType" filterable
                  placeholder="请选择规格">
                  <el-option key="饮片" label="饮片" value="饮片"> </el-option>
                  <el-option key="颗粒" label="颗粒" value="颗粒" :disabled="!piecesWeight"> </el-option>
                </el-select>
                <template v-if="medicineType == '饮片'">
                  饮片：
                  <el-input v-model="weight2" type="number" placeholder="饮片重量(g)"
                    @input="changeweight2()" style="width: 120px; margin-right: 10px"></el-input>
                </template>
                <template v-if="medicineType == '颗粒'">
                  颗粒：
                  <el-input v-model="weight" type="number" placeholder="颗粒重量(g)"
                    @input="changeweight()" style="width: 120px; margin-right: 10px"></el-input>
                </template>
                <el-button type="primary" style="width: 150px; margin-left: 20px" @click="addDrug">添加</el-button>
                <el-button type="danger" style="width: 150px; margin-left: 20px" @click="delDrug">全部删除</el-button>
              </div>
              <!-- <span
          style="
            display: flex;
            flex-direction: row;
            color: #999999;
            font-size: 14px;
            margin-left: 85px;
            margin-top: 4px;
          "
          >可用汉字或拼音首字母搜索。</span
        > -->
              <div class="drug-table-wrap">
                <el-table class="drug-table" :data="selectDrugList" :border="true" :span-method="arraySpanMethod"
                  :row-class-name="tableRowClassName">
                  <el-table-column label="序号" align="left">
                    <template slot-scope="scope">
                      <span v-if="scope.row.value === -1" class="summary-row-total">
                        {{ scope.row.index }}
                      </span>
                      <span v-else>{{ scope.row.index }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="label" label="药品名称"></el-table-column>
                  <el-table-column prop="weight" label="饮片重量(g)">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.weight" type="number" class="cell-weight-input" placeholder="重量(g)"
                        @input="
                          (val) => {
                            numberChange(val, scope.$index);
                          }
                        " @keyup.native.enter></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="weight" label="颗粒重量(g)">
                    <template slot-scope="scope">
                      <el-input
                        v-if="scope.row.piecesWeight"
                        v-model="scope.row.klWeight"
                        type="number"
                        class="cell-weight-input"
                        placeholder="重量(g)"
                        @input="
                          (val) => {
                            klNumberChange(val, scope.$index);
                          }
                        "
                        @keyup.native.enter
                      ></el-input>
                      <span v-else class="cell-granule">该饮片无颗粒</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="deleteClick(scope.row)"
                        v-show="scope.row.value !== -1">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>

                <!-- 表格外部：使用方法和禁忌（与总计行视觉连成一片） -->
                <div class="info-section" v-if="useInstructions">
                  <span class="info-row-label">使用方法：</span>
                  <span class="info-row-value">{{ useInstructions }}</span>
                </div>
                <div class="info-section" v-if="taboo">
                  <span class="info-row-label">禁忌：</span>
                  <span class="info-row-value">{{ taboo }}</span>
                </div>
              </div>
            </section>
          </div>


        </div>

        <div class="footer-actions">
          <button class="btn-confirm" @click="confirm">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            组方确认
          </button>
        </div>
      </section>
    </div>
    <el-dialog title="协定处方列表" :visible.sync="dialogjdmf" width="70%" custom-class="green-dialog">
      <div class="contact-header" style="margin-bottom: 15px;">
        <el-select v-model="clinicalDepartment" @change="clinicalDepartmentChange" placeholder="请选择科室"
          style="width: 150px; margin-right: 10px;" clearable>
          <el-option v-for="n in departmentList" :key="n.clinicalDepartment" :label="n.clinicalDepartment"
            :value="n.clinicalDepartment"></el-option>
        </el-select>
        <el-select v-model="medicalConditionName" :placeholder="clinicalDepartment == '' ? '请先选择科室' : '请选择病症'"
          style="width: 150px; margin-right: 10px;" clearable @change="search">
          <el-option v-for="n in medicalConditionNameList" :key="n.medicalConditionName" :label="n.medicalConditionName"
            :value="n.medicalConditionName"></el-option>
        </el-select>
        <el-input class="input-circle" v-model="searchText" placeholder="方剂名称、功效、主治症状"></el-input>
        <el-button class="input-search" round type="primary" @click="search">搜 索</el-button>
      </div>
      <el-table class="green-table" :border="true" :data="classicPrescriptionsList">
        <el-table-column prop="medicalConditionName" label="病症" align="center">
        </el-table-column>
        <el-table-column align="center" label="主治症状">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" :content="scope.row.mainEvidence" placement="bottom">
              <div class="single-line">{{ scope.row.mainEvidence }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="governance" label="功效" align="center">
        </el-table-column>
        <el-table-column prop="recipe" align="center" label="方剂名">
        </el-table-column>

        <el-table-column fixed="right" align="center" width="140" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="opendrawer(scope.row)">
              详情
            </el-button>
            <el-button type="text" size="medium" @click="addjdmf(scope.row)">
              载入处方
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="classicPrescriptionsListinfo.total > 5" class="pagination" background
        layout="prev, pager, next" :page-size="classicPrescriptionsListinfo.pageSize"
        :current-page="classicPrescriptionsListinfo.pageNum" @current-change="pageChange2"
        :total="classicPrescriptionsListinfo.total">
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogjdmf = false">取 消</el-button>
        <el-button type="primary" @click="dialogjdmf = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer title="协定方详情" :visible.sync="drawer" :direction="direction">
      <ul class="basic-info">
        <li><b>病症：</b>{{ drawerinfo.medicalConditionName }}</li>
        <li><b>主治症状：</b>{{ drawerinfo.mainEvidence }}</li>
        <li><b>功效：</b>{{ drawerinfo.governance }}</li>
        <li><b>方剂名：</b>{{ drawerinfo.recipe }}</li>
        <li><b>药方内容：</b>{{ drawerinfo.prescriptionContent }}</li>
        <li v-if="drawerinfo.useInstructions">
          <b>使用方法：</b>{{ drawerinfo.useInstructions }}
        </li>
        <li v-if="drawerinfo.taboo"><b>禁忌：</b>{{ drawerinfo.taboo }}</li>
      </ul>
    </el-drawer>
    <el-dialog title="历史处方列表" :visible.sync="dialoglscf" width="70%" custom-class="green-dialog">
      <el-table class="green-table" :border="true" :data="historyPrescriptions">
        <el-table-column prop="createTime" align="center" label="接诊时间">
        </el-table-column>
        <el-table-column prop="disease" align="center" label="询诊结果">
        </el-table-column>
        <el-table-column align="center" label="详情">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="gitInfo(scope.row.visitRecordId)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" width="140" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="addlscf(scope.row)">
              载入处方
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="historyPrescriptionsinfo.total > 5" class="pagination" background layout="prev, pager, next"
        :page-size="historyPrescriptionsinfo.pageSize" :current-page="historyPrescriptionsinfo.pageNum"
        @current-change="pageChange" :total="historyPrescriptionsinfo.total">
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialoglscf = false">取 消</el-button>
        <el-button type="primary" @click="dialoglscf = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SymptomTable from '@/components/fulfillment/common/SymptomTable.vue'
export default {
  components: { SymptomTable },
  data() {
    return {
      allDrugList: [],
      drugList: [],
      selectDrugList: [],
      selectDrug: "",
      medicineType: "饮片",
      weight: "",
      weight2: "",
      diagnoseResult: "",
      takeMedTime: "",
      diagnosisType: "",
      startDate: "",
      endDate: "",
      piecesWeight: "",
      submitData: null,
      dialogjdmf: false,
      dialoglscf: false,
      classicPrescriptionsList: [],
      classicPrescriptionsListinfo: {
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      historyPrescriptions: [],
      historyPrescriptionsinfo: {
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      searchText: "",
      patientId: "",
      drawer: false,
      direction: "rtl",
      clinicalDepartment: "",
      medicalConditionName: "",
      departmentList: [],
      medicalConditionNameList: [],
      drawerinfo: "",
      taboo: "",
      useInstructions: "",
    };
  },
  computed: {
    basicTableArray() {
      if (!this.submitData) return []
      var arr = []
      if (this.submitData.basic_array) arr = arr.concat(this.submitData.basic_array)
      if (this.submitData.basic_enter_array) arr = arr.concat(this.submitData.basic_enter_array)
      if (this.submitData.maixiang_array) arr = arr.concat(this.submitData.maixiang_array)
      return arr
    },
    shangjiaoTableArray() {
      return this.submitData ? this.submitData.shangjiao_array || [] : []
    },
    zhongjiaoTableArray() {
      return this.submitData ? this.submitData.zhongjiao_array || [] : []
    },
    xiajiaoTableArray() {
      return this.submitData ? this.submitData.xiajiao_array || [] : []
    },
    herbCount() {
      return this.selectDrugList.filter(item => item.value > 0).length;
    },
    herbTotalWeight() {
      var total = 0;
      this.selectDrugList.forEach((item) => {
        if (item.value > 0) {
          total += item.weight > 0 ? Number(item.weight) : 0;
        }
      });
      return total;
    },
  },
  mounted() {
    this.submitData = JSON.parse(sessionStorage.getItem("submitData"));
    var drugList = JSON.parse(sessionStorage.getItem("selectDrugList"));
    if (
      drugList &&
      drugList != null &&
      drugList != undefined &&
      drugList != ""
    ) {
      this.selectDrugList = drugList;
    }
    var handMakeInfo = JSON.parse(sessionStorage.getItem("handMakeInfo"));
    if (handMakeInfo) {
      this.diagnoseResult = handMakeInfo.diagnoseResult;
      this.takeMedTime = handMakeInfo.takeMedTime;
      this.diagnosisType = handMakeInfo.diagnosisType;
    }
    if (JSON.parse(sessionStorage.getItem("consultInfo")).contact) {
      this.patientId = JSON.parse(
        sessionStorage.getItem("consultInfo")
      ).contact.patientId;
    } else {
      this.patientId = JSON.parse(
        sessionStorage.getItem("consultInfo")
      ).patientId;
    }
    this.getDrugList();
    this.gethistoryPrescriptions();
    this.getdepartmentList();
  },
  methods: {
    opendrawer(e) {
      this.drawer = true;
      console.log(e);
      this.drawerinfo = e;
    },
    openClassicPrescriptions() {
      this.classicPrescriptionsListinfo.pageNum = 1;
      this.searchText = "";
      this.clinicalDepartment = "";
      this.medicalConditionName = "";
      this.medicalConditionNameList = [];
      this.getclassicPrescriptionsList();
      this.dialogjdmf = true;
    },
    clinicalDepartmentChange(e) {
      this.medicalConditionName = "";
      if (!e) {
        this.medicalConditionNameList = [];
        this.search();
        return;
      }
      this.wjtHttp.get(
        this,
        "/api/business/classicPrescriptions/medicalConditionNameList",
        {
          clinicalDepartment: e,
        },
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.medicalConditionNameList = data.data;
          } else {
            this.$message({
              message: data.msg && data.msg.length > 0 ? data.msg : "获取异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
      this.search();
    },
    getdepartmentList() {
      this.wjtHttp.get(
        this,
        "/api/business/classicPrescriptions/departmentList",
        {},
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            // this.dialogjdmf = true
            this.departmentList = res.data.data;
          } else {
            this.$message({
              message: data.msg && data.msg.length > 0 ? data.msg : "获取异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    gitInfo(e) {
      this.$router.push({
        path: "/commonHandmadePrescriptionDetails",
        query: {
          visitRecordId: e,
          type: 2,
        },
      });
    },
    addjdmf(e) {
      console.log(e.prescriptionContent);
      var jdmfList = e.prescriptionContent.split("、");
      console.log(jdmfList);
      var addList = [];
      jdmfList.forEach((item, index) => {
        var listItem = "";
        var name = item.split("：")[0];
        listItem = this.drugList.find((item2) => item2.label == name);
        if (listItem) {
          listItem.weight = Number.parseInt(item.split("：")[1].split("克")[0]);
          listItem.index = index + 1;
          // 同步计算颗粒重量
          if (listItem.piecesWeight && listItem.weight) {
            listItem.klWeight =
              Math.round((listItem.weight / listItem.piecesWeight) * 100) / 100;
          } else {
            listItem.klWeight = "";
          }
          addList.push(listItem);
        }
      });
      console.log(addList);
      this.selectDrugList = addList;
      var index = addList.length;

      var totalWeight = 0;
      this.selectDrugList.forEach(
        (item) =>
          (totalWeight += item.weight > 0 ? Number(item.weight) : 0)
      );
      if (this.selectDrugList.length) {
        this.selectDrugList.push({
          value: -1,
          label: "",
          weight: "0",
          index: "总计：" + index + "味，" + totalWeight + "克；",
        });
      }
      this.useInstructions = e.useInstructions || "";
      this.taboo = e.taboo || "";
      this.dialogjdmf = false;
    },
    addlscf(e) {
      var prescriptionInfos = e.prescriptionInfos || [];
      var addList = [];

      prescriptionInfos.forEach((item, idx) => {
        // 从 drugList 中根据药品名称匹配，获取正确的 value（药品ID）
        var matchDrug = this.drugList.find((d) => d.label === item.label);

        var piecesWeight = matchDrug
          ? (Number(item.piecesWeight) || matchDrug.piecesWeight)
          : (Number(item.piecesWeight) || 0);
        var weight = Number(item.weight) || 0;
        var klWeight = "";
        if (piecesWeight && weight) {
          klWeight = Math.round((weight / piecesWeight) * 100) / 100;
        }

        if (matchDrug) {
          // 匹配成功：使用 drugList 中的 value 作为唯一标识
          addList.push({
            value: matchDrug.value,
            label: item.label,
            pinYin: matchDrug.pinYin || "",
            piecesWeight: piecesWeight,
            weight: weight,
            klWeight: klWeight,
            index: idx + 1
          });
        } else {
          // 未匹配到：使用 label + 索引生成临时唯一标识
          addList.push({
            value: "temp_" + item.label + "_" + idx,
            label: item.label,
            pinYin: item.pinYin || "",
            piecesWeight: piecesWeight,
            weight: weight,
            klWeight: klWeight,
            index: idx + 1
          });
        }
      });

      this.selectDrugList = addList;
      var totalCount = addList.length;
      var totalWeight = 0;
      this.selectDrugList.forEach(
        (item) => (totalWeight += item.weight > 0 ? Number(item.weight) : 0)
      );

      if (this.selectDrugList.length > 0) {
        this.selectDrugList.push({
          value: -1,
          label: "",
          weight: "0",
          index: "总计：" + totalCount + "味，" + totalWeight + "克；",
        });
      }

      this.useInstructions = e.useInstructions || "";
      this.taboo = e.taboo || "";
      this.dialoglscf = false;
    },
    search() {
      this.currentPageNo = 1;
      this.getclassicPrescriptionsList();
    },
    pageChange2(pageNo) {
      this.classicPrescriptionsListinfo.pageNum = pageNo;
      this.getclassicPrescriptionsList();
    },
    pageChange(pageNo) {
      this.historyPrescriptionsinfo.pageNum = pageNo;
      this.gethistoryPrescriptions();
    },
    getclassicPrescriptionsList() {
      this.wjtHttp.get(
        this,
        "/api/business/classicPrescriptions/list",
        {
          prescriptionName: this.searchText,
          clinicalDepartment: this.clinicalDepartment,
          medicalConditionName: this.medicalConditionName,
          pageNum: this.classicPrescriptionsListinfo.pageNum,
          pageSize: this.classicPrescriptionsListinfo.pageSize,
        },
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.classicPrescriptionsList = data.rows;
            this.classicPrescriptionsListinfo.total = data.total;
          } else {
            this.$message({
              message: data.msg && data.msg.length > 0 ? data.msg : "获取异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    gethistoryPrescriptions() {
      this.wjtHttp.get(
        this,
        "/api/health/v1/prescription/historyPrescriptions",
        {
          patientId: this.patientId,
          pageNum: this.historyPrescriptionsinfo.pageNum,
          pageSize: this.historyPrescriptionsinfo.pageSize,
        },
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.historyPrescriptions = data.rows;
            this.historyPrescriptionsinfo.total = data.total;
          } else {
            this.$message({
              message: data.msg && data.msg.length > 0 ? data.msg : "获取异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },

    goBack() {
      this.$router.go(-1);
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.value === -1 && columnIndex === 0) {
        return [1, 5];
      }
      if (row.value === -1 && columnIndex > 0) {
        return [0, 0];
      }
    },
    changeSelect(e) {
      this.weight2 = "";
      this.weight = "";
      this.medicineType = "饮片";
      var drug = this.drugList.find((item) => item.value == this.selectDrug);
      this.piecesWeight = drug.piecesWeight;
    },
    changeweight() {
      // 颗粒模式：输入颗粒克数，同步换算饮片克数并回填饮片框
      // 公式：饮片克数 = 颗粒克数 × piecesWeight
      // （表格"颗粒重量(g)"列 = Math.round(饮片×100/piecesWeight)/100，即 饮片÷piecesWeight 保留两位，二者互为逆算）
      if (!this.piecesWeight) {
        this.weight2 = "";
        return;
      }
      this.weight2 =
        Math.round(this.weight * this.piecesWeight * 1000000) / 1000000;
    },
    changeweight2() {
      // 饮片模式：输入饮片克数，同步换算颗粒克数并回填颗粒框
      // 公式：颗粒克数 = 饮片克数 ÷ piecesWeight
      if (!this.piecesWeight) {
        this.weight = "";
        return;
      }
      this.weight =
        Math.round((this.weight2 / this.piecesWeight) * 1000000) / 1000000;
    },
    numberChange(value, index) {
      this.selectDrugList[index].weight = value;
      // 同步更新颗粒重量：颗粒 = 饮片 ÷ piecesWeight
      var row = this.selectDrugList[index];
      if (row.piecesWeight) {
        var kl = value / row.piecesWeight;
        row.klWeight = kl ? Math.round(kl * 100) / 100 : "";
      }
      this.updateTotalRow();
    },
    klNumberChange(value, index) {
      this.selectDrugList[index].klWeight = value;
      // 同步更新饮片重量：饮片 = 颗粒 × piecesWeight
      var row = this.selectDrugList[index];
      if (row.piecesWeight) {
        var wp = value * row.piecesWeight;
        row.weight = wp ? Math.round(wp * 100) / 100 : "";
      }
      this.updateTotalRow();
    },
    updateTotalRow() {
      var totalWeight = 0;
      var drugCount = 0;
      this.selectDrugList.forEach((item) => {
        if (item.value > 0) {
          drugCount++;
          totalWeight += item.weight > 0 ? Number(item.weight) : 0;
        }
      });
      var drug = this.selectDrugList.find((item) => item.value == -1);
      if (drug) {
        drug.index = "总计：" + drugCount + "味，" + totalWeight + "克；";
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.value === -1) {
        return "total-row";
      }
      return "";
    },
    startDateChange(val) {
      var flag = this.utils.afterDateFromCurrent(val);
      setTimeout(() => {
        if (!flag) {
          this.startDate = "";
          this.$message({
            message: "开始日期必须大于当前日期",
            type: "warning",
          });
        }
      }, 100);
    },
    endDateChange(val) {
      var flag = this.utils.afterDateFromCurrent(val);
      setTimeout(() => {
        if (!flag) {
          this.endDate = "";
          this.$message({
            message: "结束日期必须大于当前日期",
            type: "warning",
          });
        }
      }, 100);
    },
    //筛选
    customFilter(value) {
      if (value) {
        //val存在
        this.drugList = this.allDrugList.filter((item) => {
          if (
            !!~item.label.indexOf(value) ||
            !!~item.pinYin.toUpperCase().indexOf(value.toUpperCase())
          ) {
            return true;
          }
        });
        console.log("过滤回调1：" + value);
      } else {
        //val为空时，还原数组
        this.drugList = this.allDrugList;
        console.log("过滤回调2：" + value);
      }
    },
    getDrugList() {
      this.wjtHttp.get(
        this,
        "/api/medicine/commonMedicineList",
        {
          medicineForm: "M",
        },
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            var list = data.data;
            for (var i = 0; i < list.length; i++) {
              var netDrug = list[i];
              var drug = {
                value: netDrug.medicineId,
                label: netDrug.medicineName,
                pinYin: netDrug.pinyinInitialName,
                piecesWeight: netDrug.piecesWeight,
                weight: 0,
              };
              this.drugList.push(drug);
              this.allDrugList.push(drug);
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "获取中草药形态异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    // addDrug() {
    //   if (this.selectDrug.length == 0) {
    //     this.$message("请选择一个药品");
    //     return;
    //   }
    //   if (this.weight == 0) {
    //     this.$message("请输入药品重量");
    //     return;
    //   }
    //   var drug = this.selectDrugList.find(
    //     (item) => item.value == this.selectDrug
    //   );
    //   if (drug != null) {
    //     this.$message("不能选择同一个药品");
    //     return;
    //   }

    //   var drug = this.drugList.find((item) => item.value == this.selectDrug);
    //   drug.weight = this.weight;
    //   drug.index =
    //     this.selectDrugList.length == 0 ? 1 : this.selectDrugList.length;
    //   this.selectDrugList.splice(this.selectDrugList.length - 1, 0, drug);
    //   this.selectDrug = "";
    //   this.drugList = this.allDrugList;
    //   this.weight = "";
    //   this.weight2 = "";
    //   this.medicineType = "饮片";
    //   var totalWeight = 0;
    //   console.log(this.selectDrugList);
    //   this.selectDrugList.forEach((item) => {
    //     console.log(item.weight.length);
    //     totalWeight += item.weight > 0 ? item.weight : 0;
    //   });
    //   console.log(totalWeight);
    //   if (this.selectDrugList.length == 1) {
    //     this.selectDrugList.push({
    //       value: -1,
    //       label: "",
    //       weight: "0",
    //       index: "总计：" + drug.index + "味，" + totalWeight + "克；",
    //     });
    //   } else {
    //     this.selectDrugList[this.selectDrugList.length - 1].index =
    //       "总计：" + drug.index + "味，" + totalWeight + "克；";
    //   }
    //   console.log(this.selectDrugList);
    // },
    delDrug() {
      this.$confirm("是否全部删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.selectDrugList = [];
          this.useInstructions = "";
          this.taboo = "";
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    addDrug() {
      if (this.selectDrug.length == 0) {
        this.$message("请选择一个药品");
        return;
      }
      var repeatDrug = this.selectDrugList.find(
        (item) => item.value == this.selectDrug
      );
      if (repeatDrug != null) {
        this.$message("不能选择同一个药品");
        return;
      }

      var drug = this.drugList.find((item) => item.value == this.selectDrug);
      // 按规格分支换算：入表 weight 恒存饮片克数
      if (this.medicineType == "颗粒") {
        if (!this.piecesWeight) {
          this.$message(drug.label + "无颗粒规格，无法按颗粒添加");
          return;
        }
        if (!(Number(this.weight) > 0)) {
          this.$message("请输入颗粒重量(g)");
          return;
        }
        // 饮片克数 = 颗粒克数 × piecesWeight，回填饮片框便于核对
        this.weight2 =
          Math.round(this.weight * this.piecesWeight * 1000000) / 1000000;
      } else {
        if (!(Number(this.weight2) > 0)) {
          this.$message("请输入饮片重量(g)");
          return;
        }
        this.weight = this.weight2;
      }
      drug.weight = Number(this.weight2) || "";
      // 添加时同步计算颗粒重量，保证表格颗粒列有初始值
      if (drug.piecesWeight && drug.weight) {
        drug.klWeight =
          Math.round((drug.weight / drug.piecesWeight) * 100) / 100;
      } else {
        drug.klWeight = "";
      }
      var drugCount = this.selectDrugList.filter(item => item.value > 0).length;
      drug.index = drugCount + 1;

      // 在总计行之前插入新药品
      var totalIndex = this.selectDrugList.findIndex(item => item.value === -1);
      if (totalIndex === -1) {
        // 还没有总计行，直接追加
        this.selectDrugList.push(drug);
      } else {
        this.selectDrugList.splice(totalIndex, 0, drug);
      }

      this.selectDrug = "";
      this.drugList = this.allDrugList;
      this.weight = "";
      this.weight2 = "";
      var totalWeight = 0;
      this.selectDrugList.forEach(
        (item) =>
          (totalWeight += item.weight > 0 ? Number.parseInt(item.weight) : 0)
      );

      drugCount = this.selectDrugList.filter(item => item.value > 0).length;

      var totalRow = this.selectDrugList.find(item => item.value === -1);
      if (totalRow) {
        totalRow.index =
          "总计：" + drugCount + "味，" + totalWeight + "克；";
      } else {
        this.selectDrugList.push({
          value: -1,
          label: "",
          weight: "0",
          index: "总计：" + drugCount + "味，" + totalWeight + "克；",
        });
      }
    },
    deleteClick(drug) {
      this.selectDrugList.splice(
        this.selectDrugList.findIndex((item) => item.value == drug.value),
        1
      );
      var drugRows = this.selectDrugList.filter(item => item.value > 0);
      drugRows.forEach((item, index) => {
        item.index = index + 1;
      });
      if (drugRows.length === 0) {
        // 没有药品了，清除所有特殊行
        this.selectDrugList = [];
        this.useInstructions = "";
        this.taboo = "";
      } else {
        var totalWeight = 0;
        drugRows.forEach((item) => {
          totalWeight += item.weight > 0 ? Number.parseInt(item.weight) : 0;
        });
        var totalRow = this.selectDrugList.find(item => item.value === -1);
        if (totalRow) {
          totalRow.index =
            "总计：" + drugRows.length + "味，" + totalWeight + "克；";
        }
      }
    },
    confirm() {
      if (this.diagnoseResult.length == 0) {
        this.$message("请输入诊断结果");
        return;
      }
      if (this.takeMedTime.length == 0) {
        this.$message("请选择服药时间");
        return;
      }
      if (this.diagnosisType.length == 0) {
        this.$message("请选择接诊类型");
        return;
      }
      if (this.selectDrugList.length == 0) {
        this.$message("请添加药方");
        return;
      }
      var drug;
      this.selectDrugList.forEach((item) => {
        if (
          item.value > 0 &&
          (item.weight <= 0 || item.weight == "")
        ) {
          drug = item;
        }
      });
      if (drug) {
        this.$message(drug.label + "的重量必须是大于0的数字");
        return;
      }
      sessionStorage.setItem(
        "selectDrugList",
        JSON.stringify(this.selectDrugList)
      );
      sessionStorage.setItem(
        "handMakeInfo",
        JSON.stringify({
          diagnoseResult: this.diagnoseResult,
          takeMedTime: this.takeMedTime,
          diagnosisType: this.diagnosisType,
          useInstructions: this.useInstructions,
          taboo: this.taboo,
        })
      );
      this.$router.push("/commonHandmadePrescriptionConfirm");
    },
    generateTableData(prescriptions) {
      var tablePrescription = [];
      for (var i = 0; i < prescriptions.length; i++) {
        var table_data_item = {};
        var item = prescriptions[i];
        table_data_item.count = item.count;
        table_data_item.charge = item.charge;
        table_data_item.totalWeight = item.totalWeight;
        table_data_item.startDate = item.startDate;
        table_data_item.endDate = item.endDate;
        table_data_item.title = item.name;
        table_data_item.takeTime = item.takeTime;
        table_data_item.disease = item.disease;
        var itemArray = item.prescription;
        for (var j = 0; j < item.prescription.length; j++) {
          var itemJ = item.prescription[j];
          if (j % 2 == 1) {
            itemArray[j - 1].key1 = itemJ.key;
            itemArray[j - 1].value1 = itemJ.value;
            itemArray[j - 1].index1 = itemJ.index;
            itemArray[j - 1].visible1 = false;
          } else {
            itemArray[j].visible = false;
          }
        }
        var options = [];
        for (var k = 0; k < itemArray.length; k++) {
          if (k % 2 == 0) {
            options.push(itemArray[k]);
          }
        }
        table_data_item.options = options;
        tablePrescription.push(table_data_item);
      }
      return tablePrescription;
    },
  },
};
</script>

<style>
.el-tooltip__popper {
  font-size: 16px !important;
}

.contact-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.input-circle {
  width: 300px;
  height: 40px;
  margin-right: 20px;
}

.input-search {
  height: 40px;
  width: 100px;
  background: #20863F;
  border-color: #20863F;
}

.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.basic-info {
  margin-top: 24px;
  margin-bottom: 15px;
  padding-right: 15px;
}

.basic-info>li {
  color: #385846;
  font-size: 16px;
  text-align: left;
  line-height: 38px;
}

.basic-info>li>b {
  font-weight: bold;
  color: #08301f;
}

.green-table {
  border: 1px solid #d3e6d8;
  border-radius: 14px;
  overflow: hidden;
}

.green-table.el-table--border {
  border-color: #d3e6d8;
}

.green-table.el-table--border th.el-table__cell,
.green-table.el-table--border td.el-table__cell {
  border-color: #d3e6d8;
}

.green-table th.el-table__cell {
  background: #20863F !important;
  color: #fff !important;
  font-weight: 700 !important;
}

.green-table td.el-table__cell {
  color: #385846;
}

.green-table.el-table::before {
  display: none;
}

.green-table .el-button--text {
  color: #287b4c;
}

.green-table .el-button--text:hover {
  color: #1f7b4a;
}

.green-dialog .el-dialog__header {
  border-bottom: 1px solid #e3eee7;
}

.green-dialog .el-dialog__title {
  color: #08301f;
  font-weight: 700;
}

.green-dialog .el-button--primary {
  background: #20863F;
  border-color: #20863F;
}
</style>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  background: #f5faf6;
  padding-bottom: 40px;
}

.page-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 28px 24px;
}

/* 顶部 */
.page-head {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 22px;
  border-radius: 999px;
  border: 1px solid #bbdac8;
  background: #fff;
  color: #1c7447;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-back:hover {
  background: #f3fbf6;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #052b1c;
  line-height: 1.2;
  margin: 0;
}

.page-subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  color: #94a3b8;
}

/* 主白卡 */
.main-card {
  background: #fff;
  border: 1px solid rgba(5, 43, 28, 0.1);
  border-radius: 28px;
  box-shadow: 0 14px 35px rgba(25, 70, 43, 0.07);
  padding: 28px;
}

.main-grid {
  display: block;
}

.main-left {
  min-width: 0;
}

.symptom-card {
  margin-left: 10px;
  margin-bottom: 18px;
  margin-top: -10.59px;
}

/* 小节 */
.section-block {
  border-bottom: 1px solid rgba(5, 43, 28, 0.1);
  padding-bottom: 26px;
}

.section-block-gap {
  border-bottom: none;
  padding-bottom: 0;
  padding-top: 26px;
}

.section-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.section-head-between {
  justify-content: space-between;
}

.section-head-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-bar {
  width: 4px;
  height: 22px;
  border-radius: 999px;
  background: #20863F;
  display: inline-block;
}

.section-title {
  font-size: 21px;
  font-weight: 700;
  color: #08301f;
  margin: 0;
}

.count-badge {
  background: #eef8f1;
  color: #287b4c;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 12px;
  border-radius: 999px;
  white-space: nowrap;
}

/* el-form 项水平排列 */
.section-body ::v-deep .el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}

.section-body ::v-deep .el-form-item__label {
  float: none;
  width: 140px !important;
  text-align: left;
  padding: 0 12px 0 0;
  color: #274837;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.4;
}

.section-body ::v-deep .el-form-item__content {
  flex: 1;
  margin-left: 0 !important;
}

.section-body ::v-deep .el-radio-group {
  display: flex;
  gap: 12px;
}

.section-body ::v-deep .el-radio-button {
  margin: 0;
}

.section-body ::v-deep .el-radio-button .el-radio-button__inner {
  border: 1px solid #e2e8f0;
  border-radius: 12px !important;
  padding: 10px 22px;
  font-weight: 700;
  color: #64748b;
  box-shadow: none !important;
  transition: all 0.2s;
}

.section-body ::v-deep .el-radio-button.is-active .el-radio-button__inner {
  border-color: #20863F;
  background: #e9f6ed;
  color: #26794a;
}

.section-body ::v-deep .el-input__inner {
  border-radius: 12px;
  border-color: #e2e8f0;
}

.section-body ::v-deep .el-textarea__inner {
  border-radius: 12px;
  border-color: #e2e8f0;
  min-height: 86px;
}

/* 经典名方 / 历史处方 */
.btnBox {
  display: flex;
  gap: 12px;
  margin-top: 4px;
}

.btnBox ::v-deep .el-button {
  border-radius: 12px;
  border-color: #b9d9c4;
  background: #fff;
  /* color: #277b4d; */
  font-weight: 700;
  width: auto;
  padding: 10px 18px;
}

.btnBox ::v-deep .el-button:hover {
  background: #f3fbf6;
}

/* 表格外部：使用方法和禁忌（与总计行视觉连成一片） */
.info-section {
  background: #f7fbf8;
  padding: 10px 16px;
  text-align: right;
  line-height: 1.6;
  border-top: 1px solid #e8efea;
}

.info-section:first-of-type {
  border-top: none;
}

.info-section:last-of-type {
  border-bottom-left-radius: 13px;
  border-bottom-right-radius: 13px;
}

.info-row-label {
  color: #287b4c;
  font-weight: 700;
  white-space: nowrap;
  margin-right: 6px;
}

.info-row-value {
  color: #385846;
  white-space: pre-wrap;
  word-break: break-all;
  text-align: right;
}

/* 添加表单 */
.add-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  background: #f6fbf7;
  padding: 16px;
  border-radius: 16px;
  margin-bottom: 10px;
}

.add-form ::v-deep .el-select .el-input__inner,
.add-form ::v-deep .el-input__inner {
  border-radius: 12px;
  height: 44px;
  border-color: #e2e8f0;
}

.add-form ::v-deep .el-button {
  border-radius: 12px;
  font-weight: 700;
}

.add-form ::v-deep .el-button--primary {
  background: #20863F;
  border-color: #20863F;
}

.add-form ::v-deep .el-button--danger {
  background: #fff;
  border-color: #f0b4b4;
  color: #d97070;
}

.section-body ::v-deep .el-form {
  margin-top: 0 !important;
}

.add-form+span {
  display: flex !important;
  align-items: center;
  gap: 6px;
  color: #94a3b8 !important;
  font-size: 12px !important;
  margin: 10px 0 0 0 !important;
}

/* 药品表 */
.drug-table-wrap {
  margin-top: 16px;
  border: 1px solid #d3e6d8;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
}

.drug-table {
  width: 100% !important;
}

.drug-table ::v-deep .el-table {
  border: none;
  border-radius: 0;
  overflow: visible;
}

.drug-table ::v-deep .el-table__header-wrapper,
.drug-table ::v-deep .el-table__body-wrapper {
  border-radius: 0;
  overflow: hidden;
}

.drug-table ::v-deep .el-table__header thead tr:first-child th:first-child {
  border-top-left-radius: 13px;
}

.drug-table ::v-deep .el-table__header thead tr:first-child th:last-child {
  border-top-right-radius: 13px;
}

/* el-table 底部无圆角，让 .info-section 视觉紧贴 */
.drug-table ::v-deep .el-table__body tbody tr:last-child td:first-child,
.drug-table ::v-deep .el-table__body tbody tr:last-child td:first-child .cell,
.drug-table ::v-deep .el-table__body tbody tr:last-child td:last-child,
.drug-table ::v-deep .el-table__body tbody tr:last-child td:last-child .cell {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.drug-table ::v-deep .el-table--border {
  border-color: #d3e6d8;
}

.drug-table ::v-deep .el-table--border th.el-table__cell,
.drug-table ::v-deep .el-table--border td.el-table__cell {
  border-color: #d3e6d8;
}

.drug-table ::v-deep th.el-table__cell {
  background: #20863F !important;
  color: #fff !important;
  font-weight: 700 !important;
}

.drug-table ::v-deep td.el-table__cell {
  color: #385846;
}

.drug-table ::v-deep .el-input__inner {
  border-radius: 10px;
  height: 38px;
  border-color: #e2e8f0;
}

.drug-table ::v-deep .el-button--text {
  color: #d97070;
}

.drug-table ::v-deep .total-row td.el-table__cell {
  background: #f7fbf8 !important;
  font-weight: 700;
  color: #08301f;
}

.drug-table ::v-deep .total-row .cell {
  padding: 10px 16px;
  text-align: left;
  color: #08301f;
  font-weight: 700;
}

.drug-table ::v-deep .el-table::before {
  display: none;
}

.cell-weight-input ::v-deep .el-input__inner {
  border-radius: 10px;
  height: 38px;
  border-color: #e2e8f0;
  width: 100px;
}

.cell-granule {
  color: #287b4c;
  font-weight: 600;
}

.footer-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  border-top: 1px solid rgba(5, 43, 28, 0.1);
  margin-top: 26px;
  padding-top: 24px;
}

.btn-confirm {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 48px;
  min-width: 230px;
  justify-content: center;
  border: none;
  border-radius: 999px;
  background: #20863F;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 10px 22px rgba(44, 132, 82, 0.22);
  transition: transform 0.15s, background 0.2s;
}

.btn-confirm:hover {
  background: #257648;
  transform: translateY(-1px);
}

.pagination {
  margin-top: 16px;
  text-align: right;
}
.form-textarea{
  display: block;
  width: 100%;
}

/* 文本域：默认一行，内容增加自动扩展，最多两行，超出后出现滚动条 */
.section-body ::v-deep .form-textarea .el-textarea__inner {
  height: auto;
  max-height: 70px; /* 两行高度，超出后出现滚动条 */
  resize: none;
  overflow-y: auto;
}

.section-body ::v-deep .form-textarea .el-form-item__content {
  overflow: visible;
}
</style>
